// AlpineJS
import Alpine from 'alpinejs'
window.Alpine = Alpine

// AlpineJS: Import & Register Any Components...
import productEnquiryForm from './components/product-enquiry-form'
import search from './components/search'
import headerUi from './components/header-ui'
Alpine.data('productEnquiryForm', productEnquiryForm)
Alpine.data('search', search)
Alpine.data('headerUi', headerUi)

// AlpineJS: Start
Alpine.start()

// Global get CSRF token function (used by forms).
window.getToken = async () => {
    return await fetch('/!/DynamicToken/refresh')
        .then((res) => res.json())
        .then((data) => {
            return data.csrf_token
        })
        .catch(function (error) {
            this.error = 'Something went wrong. Please try again later.'
        })
}

window.GAEvent = (category, action, label, value = 0) => {
	// if (typeof gtag === 'function') {
	// 	return gtag('event', action, {
	// 		'event_category': category,
	// 		'event_label': label,
	// 		'event_value': value,
	// 	});

	// see: https://stackoverflow.com/questions/15744042/events-not-being-tracked-in-new-google-analytics-analytics-js-setup
	if ("ga" in window) {
		let tracker = ga.getAll()[0];
		if (tracker) {
			tracker.send("event", {
				'eventCategory': category,
				'eventAction': action,
				'eventLabel': label,
				'eventValue': value,
			});
		}
	}
}

// Barba.js
require('./barba')
